import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  TextField,
  Typography,
  CircularProgress,
  Alert,
  Grid,
} from '@mui/material';
import { rq } from 'http/apiRoutes';

type ImportedProduct = {
  name: string;
  price: string; // behold som string for enkel redigering (kr, , .)
  imageUrl: string;
};

type Props = {
  onSave: (p: ImportedProduct) => void; // kall ditt eget lagre-endepunkt herfra
};

export function DustinImportProduct({ onSave }: Props) {
  const [url, setUrl] = useState('');
  const [data, setData] = useState<ImportedProduct | null>(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

async function handleFetch() {
  setLoading(true); setErr(null); setData(null);
  try {
    /* const { data } = await useApi.get(
      rq.importDustinMetadata(url, true).url,
      { params: rq.importDustinMetadata(url, true).params }
    ); */
    const data = {
      name: 'Eksempel Produkt fra Dustin',
      price: '1 234,56',
      imageUrl: 'https://example.com/image.jpg'
    }
    setData({
      name: data.name ?? '',
      price: data.price ?? '',
      imageUrl: data.imageUrl ?? ''
    });
  } catch (e: any) {
    setErr(e?.message ?? 'Ukjent feil');
  } finally {
    setLoading(false);
  }
}


  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label='Produkt-URL (f.eks. Dustin)'
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            fullWidth
            placeholder='Lim inn lenke til produktsiden'
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={handleFetch}
            variant='contained'
            fullWidth
            sx={{ height: '100%' }}
            disabled={!url || loading}
          >
            {loading ? <CircularProgress size={22} /> : 'Hent data'}
          </Button>
        </Grid>

        {err && (
          <Grid item xs={12}>
            <Alert severity='error'>{err}</Alert>
          </Grid>
        )}

        {data && (
          <Grid item xs={12}>
            <Card>
              {data.imageUrl && (
                <CardMedia
                  component='img'
                  image={data.imageUrl}
                  alt={data.name}
                  sx={{ objectFit: 'contain', maxHeight: 320 }}
                />
              )}
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label='Navn'
                      value={data.name}
                      onChange={(e) =>
                        setData({ ...data, name: e.target.value })
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label='Pris'
                      value={data.price}
                      onChange={(e) =>
                        setData({ ...data, price: e.target.value })
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label='Bilde-URL'
                      value={data.imageUrl}
                      onChange={(e) =>
                        setData({ ...data, imageUrl: e.target.value })
                      }
                      fullWidth
                    />
                  </Grid>
                </Grid>

                <Box mt={2} display='flex' gap={2}>
                  <Button
                    variant='contained'
                    onClick={() => data && onSave(data)}
                  >
                    Lagre
                  </Button>
                  <Typography variant='body2' color='text.secondary'>
                    Rediger feltene før du lagrer.
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
